/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Swedish
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Sida utan rubrik',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Skapa en ny sida och infoga den som en länk',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Skapa Confluence-sida',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Öppna i Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Din sida har skapats',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Sidan har skapats',
  'editorExtensionLinkCreate.confluencePage.title': 'Skapa en ny sida',
  'editorExtensionLinkCreate.genericError.description': 'Uppdatera sidan och försök igen.',
  'editorExtensionLinkCreate.genericError.title': 'Något gick fel',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description':
    'Skapa ett inline-ärende och infoga ärendet som en länk',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Skapa Jira-ärende',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Öppna i Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Ditt ärende har skapats',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Ärendet har skapats',
  'editorExtensionLinkCreate.jiraIssue.title': 'Skapa nytt ärende',
  'editorExtensionLinkCreate.keyword.create': 'skapa',
  'editorExtensionLinkCreate.keyword.issue': 'ärende',
  'editorExtensionLinkCreate.keyword.new': 'ny',
  'editorExtensionLinkCreate.keyword.page': 'sida',
  'editorExtensionLinkCreate.keyword.publish': 'publicera',
  'editorExtensionLinkCreate.keyword.raise': 'öppna',
  'editorExtensionLinkCreate.keyword.space': 'utrymme',
  'editorExtensionLinkCreate.keyword.ticket': 'ärende',
};
